import React from 'react'
import classnames from 'classnames'

import ObituaryMemoryComment from '../../ObituaryMemoryComment'
import ObituaryMemoryCommentForm, { FormValues } from '../../../forms/ObituaryMemoryCommentForm'
import {
  ObituaryMemory as IObituaryMemory,
  ObituarySnippet,
  ReactionByID,
  VisitorUser,
} from '../../../types'
import Modal from '../../Modal'
import ObituaryMemory from '../../ObituaryMemory'
import styles from './styles.module.scss'

interface Props {
  hasReaction?: boolean
  obituary: ObituarySnippet
  obituaryMemory: IObituaryMemory
  obituaryMemoryCommentFormInitialValues: FormValues
  onObituaryMemoryCommentFormSubmit: (values: FormValues) => Promise<void>
  onClose: () => void
  onLike: (memoryID: number, newUser?: VisitorUser) => Promise<void>
  onLikeComment: (commentID: number, newUser?: VisitorUser) => Promise<void>
  reactionsByCommentID: ReactionByID
  visitorUser?: VisitorUser
}

const ObituaryMemoryModal: React.FC<Props> = (props) => {
  const { visitorUser } = props
  const { comments, image } = props.obituaryMemory

  return (
    <Modal noScrollClassName="no-scroll-medium-up" onClose={props.onClose}>
      <div className={classnames({ [styles.noImageMemoryWrapper]: !image })}>
        <ObituaryMemory
          hasReaction={props.hasReaction}
          inModal={true}
          obituaryMemory={props.obituaryMemory}
          onLike={props.onLike}
          visitorUser={visitorUser}
        />
      </div>

      {comments.length > 0 ? (
        comments.map((comment) => {
          const reactionID = props.reactionsByCommentID[String(comment.id)]

          return (
            <ObituaryMemoryComment
              key={comment.id}
              comment={comment}
              hasReaction={!!reactionID}
              onLike={props.onLikeComment}
              visitorUser={visitorUser}
            />
          )
        })
      ) : (
        <div className={styles.noCommentsWrapper}>
          <p>There have been no replies to this memory. Leave the first reply below!</p>
        </div>
      )}

      <div>
        <ObituaryMemoryCommentForm
          initialValues={props.obituaryMemoryCommentFormInitialValues}
          onSubmit={(values) => props.onObituaryMemoryCommentFormSubmit(values)}
        />
      </div>
    </Modal>
  )
}

export default ObituaryMemoryModal
